import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Layout from "../layout/Layout";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./ContactList.css";


const ContactList = () => {


const navigate = useNavigate();


const API = "https://data.shreemwell.in/api/contacts";

const REQUEST_API =
"https://data.shreemwell.in/api/connection-requests";



const [contacts,setContacts]=useState([]);

const [requestMap,setRequestMap]=useState({});

const [loading,setLoading]=useState(true);

const [currentPage,setCurrentPage]=useState(1);


const recordsPerPage=50;



const [filters,setFilters]=useState({

name:"",
mobile:"",
email:"",
location:""

});





// ===============================
// Filter
// ===============================


const handleFilterChange=(e)=>{

const {name,value}=e.target;


setFilters(prev=>({

...prev,

[name]:value

}));

setCurrentPage(1);

};





const clearFilters=()=>{

setFilters({

name:"",
mobile:"",
email:"",
location:""

});


setCurrentPage(1);

};







// ===============================
// Filter Data
// ===============================


const filteredContacts =
contacts.filter((item)=>{


const contact=item?.contact;


const name =
`${contact?.firstName || ""} ${contact?.lastName || ""}`
.toLowerCase();



return (

name.includes(
filters.name.toLowerCase()
)


&&


(contact?.mobile || "")
.includes(filters.mobile)



&&


(contact?.email || "")
.toLowerCase()
.includes(
filters.email.toLowerCase()
)



&&


(contact?.currentLocation || "")
.toLowerCase()
.includes(
filters.location.toLowerCase()
)


);


});





const totalPages =
Math.ceil(
filteredContacts.length / recordsPerPage
);



const indexOfLastRecord =
currentPage * recordsPerPage;


const indexOfFirstRecord =
indexOfLastRecord-recordsPerPage;



const currentContacts =
filteredContacts.slice(
indexOfFirstRecord,
indexOfLastRecord
);







// ===============================
// Fetch Contacts
// ===============================


const fetchContacts=async()=>{


try{


setLoading(true);


const token =
localStorage.getItem("token");



const res =
await axios.get(

API,

{

headers:{

Authorization:
`Bearer ${token}`

}

}

);



if(res.data.success){


setContacts(
res.data.data || []
);


}


}
catch(error){


console.log(error);

toast.error(
"Failed to load contacts"
);


}
finally{

setLoading(false);

}


};







useEffect(() => {
  fetchContacts();
  getAllRequests();

  const interval = setInterval(() => {
    getAllRequests();
  }, 2000);

  return () => clearInterval(interval);
}, []);








// ===============================
// Get My Sent Requests
// ===============================

const getAllRequests = async () => {

try {

const token = localStorage.getItem("token");


const res = await axios.get(
`${REQUEST_API}/all`,
{
headers:{
Authorization:`Bearer ${token}`
}
}
);


const map = {};

const payload =
JSON.parse(
window.atob(
token.split(".")[1]
)
);


const currentUserId =
payload.id || payload._id;



(res.data.data || []).forEach((item) => {

    const senderId = String(item.sender?._id);
    const receiverId = String(item.receiver?._id);

    // I sent request
    if (senderId === String(currentUserId)) {

        map[receiverId] = {
            status: item.status,
            mutual: item.mutual,
            requestId: item._id,
            isSender: true
        };

    }

    // I received request
    if (receiverId === String(currentUserId)) {

        map[senderId] = {
            status: item.status,
            mutual: item.mutual,
            requestId: item._id,
            isSender: false
        };

    }

});


setRequestMap(map);


}
catch(error){

console.log(error);

}

};










// ===============================
// Send Request
// ===============================

const sendRequest = async(receiverId)=>{


if(!receiverId){

toast.error(
"User account not found"
);

return;

}



try{


const token =
localStorage.getItem("token");



const res =
await axios.post(

`${REQUEST_API}/send`,

{
receiver:receiverId
},

{
headers:{
Authorization:`Bearer ${token}`
}
}

);



toast.success(
res.data.message
);



getAllRequests();



}
catch(error){


toast.error(

error.response?.data?.message ||
"Request failed"

);


}



};









// ===============================
// Delete Contact
// ===============================


const deleteContact=async(id)=>{


try{


const token =
localStorage.getItem("token");



const res =
await axios.delete(

`${API}/${id}`,

{

headers:{

Authorization:
`Bearer ${token}`

}

}

);



if(res.data.success){


toast.success(
"Contact deleted"
);


fetchContacts();


}


}
catch(error){


toast.error(
"Delete failed"
);


}


};








return (

<Layout>


<ToastContainer
position="top-right"
autoClose={3000}
theme="colored"
/>




<div className="contact-container">



<div className="contact-header">


<h2>
Contact Management
</h2>



<button

className="add-btn"

onClick={()=>navigate("/AddContact")}

>

+ Add Contact

</button>


</div>







<div className="filter-container">


<input

placeholder="Search Name"

name="name"

value={filters.name}

onChange={handleFilterChange}

/>



<input

placeholder="Search Mobile"

name="mobile"

value={filters.mobile}

onChange={handleFilterChange}

/>




<input

placeholder="Search Email"

name="email"

value={filters.email}

onChange={handleFilterChange}

/>



<input

placeholder="Search Location"

name="location"

value={filters.location}

onChange={handleFilterChange}

/>




<button

className="clear-btn"

onClick={clearFilters}

>

Clear

</button>



</div>








<div className="table-wrapper">


{

loading ?


<h3>
Loading...
</h3>


:


<table className="contact-table">


<thead>


<tr>

<th>Sr</th>
<th>First Name</th>
<th>Last Name</th>
<th>Mobile</th>
<th>Email</th>
<th>Mutual</th>
<th>Action</th>

</tr>


</thead>



<tbody>


{

currentContacts.length===0 ?


<tr>

<td colSpan="7">

No Contacts Found

</td>

</tr>


:



currentContacts.map((item,index)=>{


const contact=item?.contact;



if(!contact)
return null;



const accountId =
contact.accountId?._id ||
contact.accountId;



return (


<tr key={item._id}>


<td>

{indexOfFirstRecord+index+1}

</td>



<td>

{contact.firstName}

</td>




<td>

{contact.lastName}

</td>




<td>

{contact.mobile}

</td>




<td>

{contact.email}

</td>


<td>

{!requestMap[accountId] ? (
  <button
    className="request-btn"
    onClick={() => sendRequest(accountId)}
  >
    Send Request
  </button>
) : requestMap[accountId].mutual ? (
  <button className="mutual-btn" disabled>
    🤝 Mutual
  </button>
) : requestMap[accountId].status === "Pending" ? (
  <button className="pending-btn" disabled>
    Pending
  </button>
) : requestMap[accountId].status === "Accepted" ? (
  <button className="accepted-btn" disabled>
       🤝
  </button>
) : requestMap[accountId].status === "Hold" ? (
  <button className="hold-btn" disabled>
    Hold
  </button>
) : requestMap[accountId].status === "Rejected" ? (
  <button className="reject-btn" disabled>
    Rejected
  </button>
) : (
  <button
    className="request-btn"
    onClick={() => sendRequest(accountId)}
  >
    Send Request
  </button>
)}
</td>







<td>


<button

className="view-btn"

onClick={()=>
navigate(
`/view-contact/${contact._id}`
)
}

>

View

</button>




<button

className="edit-btn"

onClick={()=>
navigate(
`/edit-contact/${contact._id}`
)
}

>

Edit

</button>





<button

className="delete-btn"

onClick={()=>
deleteContact(contact._id)
}

>

Delete

</button>



</td>



</tr>


);


})


}



</tbody>


</table>


}







<div className="pagination">


<button

disabled={
currentPage===1
}

onClick={()=>
setCurrentPage(
currentPage-1
)
}

>

Previous

</button>




<span>

Page {currentPage} of {totalPages || 1}

</span>





<button

disabled={
currentPage===totalPages ||
totalPages===0
}

onClick={()=>
setCurrentPage(
currentPage+1
)
}

>

Next

</button>



</div>





</div>





</div>


</Layout>

);


};


export default ContactList;